import React, { Fragment } from 'react'
import { translate } from 'react-i18next'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import { SERVICES_TABS } from '../../utils/constants'
import './index.sass'
import { VideoLocalizationIcon } from './icons/videoLocalization'
import { VoiceOcerIcon } from './icons/voiceOver'
import Breadcrumbs from '../Breadcrumbs'
import ScrollUpButton from '../ScrollUpButton'

const ServicesPage = ({ t, lng }) => {
	const path = lng === 'en' ? '' : `/${lng}`
  return (
    <Fragment>
      <Helmet>
        <html lang={lng} />
        <title>{t('meta.services.title')}</title>
        <link rel="alternate" hrefLang="en"
              href="https://unimedia.io/services" />
          <link rel="alternate" hrefLang="de"
              href="https://unimedia.io/de/services" />
          <link rel="alternate" hrefLang="ru"
              href="https://unimedia.io/ru/services" />
          <link rel="alternate" hrefLang="x-default"
              href="https://unimedia.io/services" />
        <meta name="description" content={t('meta.services.descr')} />
        {lng === 'en' && <meta name="keywords" content={t('meta.services.keywords')} />}
        {lng === 'en' ? <link rel="canonical" href={'https://unimedia.io/services'} /> : <link rel="canonical" href={`https://unimedia.io/${lng}/services`} />}
        <meta property="og:title" content={t('meta.services.title')} />
        <meta property="og:description" content={t('meta.services.descr')} />
        <meta property="og:image" content="https://unimedia.io/assets/logo.svg" />
        <meta property="og:url" content={lng === 'en' ? 'https://unimedia.io/services': `https://unimedia.io/${lng}/services`} />
        <script type="application/ld+json">
        {`[{
              "@context" : "https://schema.org/",
              "@type": "Product",
              "name": "${t('productDescription')}",
              "image": "https://unimedia.io/assets/logo.svg",
              "description": "${t('meta.services.descr')}",
              "brand": {
                "@type": "Brand",
                "name": "Universal Media"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "bestRating": "5",
                "reviewCount": "5"
              }
            },
            {
                "@context": "https://schema.org",
                "@type": "Organization",
                "name": "Universal Media",
                "alternateName": "Unimedia",
                "url": "https://unimedia.io",
                "logo": "https://unimedia.io/assets/logo.svg"
            },{
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "${t('navigations.home')}",
                "item": "https://unimedia.io"
              },{
                "@type": "ListItem",
                "position": 2,
                "name": "${t('navigations.services')}",
                "item": "https://unimedia.io/services"
              }]
            }]`}
          </script>
      </Helmet>
      <ScrollUpButton id={'servicePage'} />
      <div className="services-page container overflow-y" id={'servicePage'}>
        <div className={'container-wrapper'}>
        <Breadcrumbs pathname={window.location.pathname} color='white'/>
          <h1 className="main-title">{t('services.title')}</h1>
          <div className="services-link-wrapper">
            <Link className="services-link" to={`${path}/services/video-localization`}>
              <div className="services-link-inner">
                <h5>{t(`services.${SERVICES_TABS['VIDEO_LOCALIZATION'].label}`)}</h5>
                <span className="nav-arrow" />
								<VideoLocalizationIcon />
              </div>
            </Link>
            <Link className="services-link" to={`${path}/services/voice-over`}>
              <div className="services-link-inner">
                <h5>{t(`services.${SERVICES_TABS['VOICE_OVER'].label}`)}</h5>
                <span className="nav-arrow" />
                <VoiceOcerIcon />
              </div>
            </Link>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default translate('translations')(ServicesPage)
